import { ProductPageLayout } from '../components/ProductPageLayout';

export function GoogleAiProPage() {
    return <ProductPageLayout productId="google-ai-pro" />;
}
